import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu"]
  static values = { currentMediaItem: Object }

  connect() {
    console.log("Favourite folder dropdown controller connected")
    // Close dropdown when clicking outside
    document.addEventListener('click', this.handleClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside.bind(this))
  }

  toggle() {
    if (this.menuTarget.classList.contains('hidden')) {
      this.loadFavouriteFolders()
    }
    this.menuTarget.classList.toggle('hidden')
  }

  async loadFavouriteFolders() {
    try {
      // Look for current user ID in the modal element first, then fall back to body
      const modalElement = this.element.closest('.fixed.inset-0.bg-black')
      const currentUserId = modalElement?.dataset.currentUserId || document.body.dataset.currentUserId
      
      console.log('Current user ID found:', currentUserId)
      
      if (!currentUserId) {
        console.error('Current user ID not found')
        return
      }
      
      const response = await fetch(`/users/${currentUserId}/favourites.json`, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      
      if (!response.ok) {
        console.error('Failed to fetch favourite folders:', response.status, response.statusText)
        return
      }
      
      const data = await response.json()
      this.renderFavouriteFolders(data.favourite_folders)
    } catch (error) {
      console.error('Error loading favourite folders:', error)
    }
  }

  renderFavouriteFolders(folders) {
    const menuContent = this.menuTarget.querySelector('.py-1')
    const currentUserId = document.body.dataset.currentUserId
    
    if (folders.length === 0) {
      menuContent.innerHTML = `
        <div class="px-4 py-2 text-sm text-gray-500">
          No favourite folders found. 
          <a href="/users/${currentUserId}/favourites/new" class="text-blue-600 hover:text-blue-800">Create one</a>
        </div>
      `
      return
    }
    
    menuContent.innerHTML = folders.map(folder => `
      <button 
        class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none"
        data-action="click->favourite-folder-dropdown#addToFolder"
        data-folder-id="${folder.id}"
        data-folder-name="${folder.name}">
        ${folder.name}
      </button>
    `).join('')
  }

  async addToFolder(event) {
    const folderId = event.currentTarget.dataset.folderId
    const folderName = event.currentTarget.dataset.folderName
    const mediaItemId = this.currentMediaItemValue.id
    
    try {
      const currentUserId = document.body.dataset.currentUserId
      const response = await fetch(`/users/${currentUserId}/favourites/${folderId}/add_media_item`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ media_item_id: mediaItemId })
      })
      
      const data = await response.json()
      
      if (data.success) {
        // Show success message
        this.showMessage(data.message, 'success')
      } else {
        // Show info message (like "already in folder")
        this.showMessage(data.message, 'info')
      }
    } catch (error) {
      console.error('Error adding to folder:', error)
      this.showMessage('Failed to add to folder', 'error')
    }
    
    // Hide the dropdown after selection
    this.hide()
  }

  showMessage(message, type = 'info') {
    // Create a temporary message element
    const messageEl = document.createElement('div')
    messageEl.className = 'fixed top-4 right-4 z-50 px-4 py-2 rounded-lg text-black text-sm font-medium bg-amber-50 border border-amber-200 shadow-lg'
    messageEl.textContent = message
    
    document.body.appendChild(messageEl)
    
    // Remove after 3 seconds
    setTimeout(() => {
      messageEl.remove()
    }, 3000)
  }

  hide() {
    this.menuTarget.classList.add('hidden')
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }
} 